import type { Cin7Location } from "@/api/dtos";
import type { Location } from "@/api/location/_models/Location";
import {
  toLocationAddressFromCin7Location,
  toLocationBinFromCin7LocationBin,
} from "./utils";

export const toLocationFromCin7Location = (dto: Cin7Location): Location => {
  return {
    id: dto.ID,
    name: dto.Name,
    isDefault: dto.IsDefault,
    isDeprecated: dto.IsDeprecated,
    bins: (dto.Bins ?? []).map((x) => toLocationBinFromCin7LocationBin(x)),
    isFixedAssets: dto.FixedAssetsLocation,
    parentId: dto.ParentID,
    parentName: dto.ParentName,
    referenceCount: dto.ReferenceCount,
    address: toLocationAddressFromCin7Location(dto),
    pickZones: dto.PickZones,
    isShopfloor: dto.IsShopfloor,
    isCoMan: dto.IsCoMan,
    isStaging: dto.IsStaging,
  };
};
